<template>
  <section class="primary-content-area">
    <div class="container-wrapper">
      <div class="layout-row layout-reverse">
        <div class="content-column">
          <h1 class="main-heading">AIによる革新的な株価分析システム</h1>
          <p class="description-text">
            当社の<span class="highlight-text">人工知能分析システム</span>は、市場動向、最新ニュース、過去のパターンを組み合わせて、精度の高い株価予測を実現します。効率性と正確性を<span class="highlight-text">向上させる</span>最先端技術をご体験ください。
          </p>
          <p class="description-text">
            以下に株式コードを入力すると、AIシステムが<span class="accent-text">2秒以内</span>に分析を完了します。現在、<span class="accent-text">36,968人</span>が無料で完全なレポートを閲覧中！
          </p>
        </div>
        <div class="visual-column">
          <img :src="require('@/assets/images/164.jpg')" alt="AI株価分析システム">
          <div class="visual-overlay"></div>
        </div>
      </div>

      <div class="interaction-panel">
        <div class="input-wrapper">
          <input 
            type="text" 
            class="stock-input" 
            placeholder="株式コードまたは銘柄名を入力してください..." 
            v-model="stockSymbol"
          >
          <div class="input-indicator">🔍</div>
        </div>

        <button class="analyze-button" @click="triggerAnalysis">AIで分析する</button>

        <div class="metrics-display">
          <div class="metric-item">
            <div class="metric-number">99.7%</div>
            <div class="metric-label">分析精度</div>
          </div>
          <div class="metric-item">
            <div class="metric-number">2秒</div>
            <div class="metric-label">処理時間</div>
          </div>
          <div class="metric-item">
            <div class="metric-number">36,968</div>
            <div class="metric-label">今日の利用者数</div>
          </div>
        </div>
      </div>

      <div class="capabilities-grid">
        <div class="capability-card">
          <div class="capability-icon">📊</div>
          <div class="capability-content">
            <div class="capability-heading">リアルタイム市場分析</div>
            <p class="description-text">AIが市場データを継続的に監視し、重要な動向を特定</p>
          </div>
        </div>
        <div class="capability-card">
          <div class="capability-icon">📰</div>
          <div class="capability-content">
            <div class="capability-heading">ニュースセンチメント分析</div>
            <p class="description-text">最新の金融ニュースを分析し、株価への影響を評価</p>
          </div>
        </div>
        <div class="capability-card">
          <div class="capability-icon">📈</div>
          <div class="capability-content">
            <div class="capability-heading">高度なパターン認識</div>
            <p class="description-text">過去の市場データから価格パターンとトレンドを予測</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CoreContentSection',
  data() {
    return {
      stockSymbol: ''
    }
  },
  methods: {
    triggerAnalysis() {
      this.$emit('startAnalysis', this.stockSymbol)
    }
  }
}
</script>

<style scoped>
.container-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.primary-content-area {
  display: flex;
  flex-direction: column;
  padding: 15px 0;
}

.layout-row {
  display: flex;
  gap: 20px;
  align-items: center;
  margin-bottom: 20px;
}

.layout-reverse {
  flex-direction: column-reverse;
}

.content-column {
  flex: 1;
}

.visual-column {
  flex: 1;
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(0, 224, 255, 0.3);
  max-width: 500px;
}

.visual-column img {
  width: 100%;
  display: block;
}

.visual-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, rgba(0, 22, 56, 0.5) 0%, rgba(0, 98, 255, 0.2) 100%);
}

.main-heading {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 15px;
  line-height: 1.3;
  background: linear-gradient(90deg, var(--text-main), var(--brand-secondary));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.description-text {
  font-size: 16px;
  margin-bottom: 15px;
  color: var(--text-sub);
}

.highlight-text {
  color: var(--brand-secondary);
  font-weight: 500;
}

.accent-text {
  color: var(--brand-accent);
  font-weight: 500;
}

.interaction-panel {
  background-color: rgba(0, 22, 56, 0.6);
  border-radius: 16px;
  padding: 20px;
  border: 1px solid rgba(0, 224, 255, 0.2);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  margin-bottom: 30px;
}

.input-wrapper {
  position: relative;
  margin-bottom: 15px;
}

.stock-input {
  width: 100%;
  padding: 14px;
  font-size: 16px;
  border: none;
  background-color: rgba(255, 255, 255, 0.05);
  color: var(--text-main);
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2), inset 0 0 0 1px rgba(0, 224, 255, 0.2);
  outline: none;
  transition: all 0.3s ease;
}

.stock-input:focus {
  box-shadow: 0 4px 15px rgba(0, 98, 255, 0.3), inset 0 0 0 1px rgba(0, 224, 255, 0.5);
}

.input-indicator {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--brand-secondary);
}

.analyze-button {
  display: inline-block;
  padding: 14px 28px;
  font-size: 18px;
  font-weight: 700;
  color: var(--text-main);
  background: linear-gradient(45deg, var(--brand-primary), var(--brand-secondary));
  border: none;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(0, 98, 255, 0.4);
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  animation: button-pulse 2s infinite;
  width: 100%;
  text-align: center;
}

@keyframes button-pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

.analyze-button:hover {
  box-shadow: 0 6px 20px rgba(0, 98, 255, 0.6);
  transform: translateY(-2px);
}

.analyze-button:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transform: translateX(-100%);
}

.analyze-button:hover:after {
  animation: button-shimmer 1.5s infinite;
}

@keyframes button-shimmer {
  0% { transform: translateX(-100%); }
  60%, 100% { transform: translateX(100%); }
}

.metrics-display {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}

.metric-item {
  text-align: center;
  flex: 1;
}

.metric-number {
  font-size: 20px;
  font-weight: 700;
  color: var(--brand-secondary);
}

.metric-label {
  font-size: 12px;
  color: var(--text-sub);
}

.capabilities-grid {
  display: flex;
  gap: 15px;
  margin: 30px 0 20px;
}

.capability-card {
  flex: 1;
  padding: 15px;
  background-color: rgba(0, 22, 56, 0.6);
  border-radius: 12px;
  border: 1px solid rgba(0, 224, 255, 0.1);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
}

.capability-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(0, 98, 255, 0.2);
  border-color: rgba(0, 224, 255, 0.3);
}

.capability-icon {
  width: 40px;
  height: 40px;
  background-color: rgba(0, 98, 255, 0.1);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  border: 1px solid rgba(0, 224, 255, 0.2);
  flex-shrink: 0;
}

.capability-content {
  flex: 1;
}

.capability-heading {
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 3px;
  color: var(--brand-secondary);
}

@media (max-width: 768px) {
  .layout-row {
    flex-direction: column;
  }
  
  .layout-reverse {
    flex-direction: column-reverse;
  }
  
  .visual-column {
    width: 100%;
    max-width: 100%;
    margin-bottom: 15px;
  }
  
  .capabilities-grid {
    flex-direction: column;
  }
  
  .main-heading {
    font-size: 24px;
    margin-bottom: 12px;
  }
  
  .metric-number {
    font-size: 18px;
  }
  
  .metric-label {
    font-size: 11px;
  }
  
  .description-text {
    font-size: 14px;
    margin-bottom: 12px;
  }
  
  .primary-content-area {
    padding: 10px 0;
  }
  
  .visual-column img {
    height: 180px;
    object-fit: cover;
  }
}
</style> 